<!--
 * @Author: 王枫叶
 * @Date: 2020-10-24 13:45:37
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-10-28 22:12:55
-->
<!--  -->
<template>
  <div>
    <el-dialog
      id="activity"
      title="编辑【折扣率】"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="400px"
      center
      calss="ac-dialog"
    >
      <div class="ac-dia-form">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          size="mini"
          label-width="120px"
          label-position="left"
        >
          <el-form-item label="折扣率" prop="hotCity">
            <el-input v-model.number="ruleForm.discountRate" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      dialogFormVisible: false,
      ruleForm: {
        discountRate:''
      }
      
    }
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          API.editLoufCfg(this.ruleForm).then(() => {
            this.$emit('handlerChannelList')
            this.dialogFormVisible = false
          })
        } else {
          return false
        }
      })
    },
    // 取消
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$emit('handlerChannelList')
      this.dialogFormVisible = false
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(discountRate) {
      this.dialogFormVisible = true
      this.ruleForm.discountRate = discountRate
    }
  }
}
</script>

<style lang='' scoped>
</style>
